import { createAsyncThunk } from '@reduxjs/toolkit'
import { CategoryDetailMapping, CategoryDetailService, CreateCategoryDetailService } from '@internal/services/category-detail'
import { EChangeValue, ISelectCategoryChange } from './types'
import { ICategoryDetailSliceState, IReduxThunkArg, IReduxThunkReturned } from './redux.types'

export const fetchCategoryDetailThunk = createAsyncThunk<IReduxThunkReturned, IReduxThunkArg | undefined>(
  'fetchCategoryDetailThunk',
  async (param, thunkAPI) => {
    const state = thunkAPI.getState() as { CategoryDetailSlice: ICategoryDetailSliceState }

    const sMediaId = state.CategoryDetailSlice.mediaId
    const pMediaId = param?.mediaId ?? ''
    const mediaId = !!pMediaId ? (sMediaId !== pMediaId ? pMediaId : sMediaId) : sMediaId
    const dataResult = await CategoryDetailService.GraphQLAll({ id: mediaId }, thunkAPI.signal)

    return {
      mediaId,
      categoryDetails: CategoryDetailMapping.categoryDetails(dataResult.media),
      categories: CategoryDetailMapping.categories(dataResult.categories?.items)
    }
  }
)

// ========= ========= ========= Update Category Redux ========= ========= =========
export const fetchCategoryUpdateThunk = createAsyncThunk<{}, ISelectCategoryChange>('fetchCategoryUpdateThunk', async (param, thunkAPI) => {
  // const state = thunkAPI.getState() as { CategoryDetailSlice: ICategoryDetailStateSlice }
  const CategoryDetailService = CreateCategoryDetailService(param.value.CategoryId)
  switch (param.status) {
    case EChangeValue.Add: {
      await CategoryDetailService.Create({ CategoryId: param.value.CategoryId, MediaId: param.value.MediaId }, thunkAPI.signal)
      break
    }
    case EChangeValue.Remove: {
      await CategoryDetailService.Remove(param.value.Id ?? '', thunkAPI.signal)
      break
    }
    default:
      break
  }
  thunkAPI.dispatch(fetchCategoryDetailThunk({ mediaId: param.value.MediaId }))
})
